import { IAddress } from './Address';

export interface ICDRTEvent {
  id: number;
  media: any;
  title: string;
  startDate: Date;
  endDate: Date;
  address: IAddress;
  description: string;
  extract: string;
}

export const CDRTEvent = (data: { id: number; attributes: any }): any => {
  return {
    id: data.id,
    media: data.attributes.media,
    title: data.attributes.title,
    startDate: data.attributes.startDate
      ? new Date(data.attributes.startDate)
      : null,
    endDate: data.attributes.endDate ? new Date(data.attributes.endDate) : null,
    description: data.attributes.description,
    extract: data.attributes.extract,
    address: data.attributes.address,
  };
};
